TWENTY_YEARS_IN_SEC = 630720000
TUTORIAL_SHOWN_COOKIE_NAME = 'clo-cash-back-tutorial-shown'
TUTORIAL_MODAL_SHOWN_COOKIE_NAME = 'clo-cash-back-tutorial-modal-shown'
{displayCardsUserNeedsToClaimDeal, getUserBillingRecordTypes} = require '../../frontend/helper'

CashBack =
  init: (payload, done) ->
    {cashBack, cookieDomain} = payload
    getUserBillingRecordTypes(@userTypeHandler, payload)

    if cashBack?.showTutorialTooltipOnLoad
      #If there's a banner coming from the layout service, due to its lazy loaded image we don't know when the page will be ready
      #so wait a little bit launching the tutorial popup. If there is no banner, launch right away
      tooltipDelay = if $('#ls-in-app-messages:not(.hide)').length then cashBack?.tooltipDelay || 2000 else 0
      tutorialTooltipLauncher = =>
        @showTutorialTooltip cookieDomain

      setTimeout(tutorialTooltipLauncher, tooltipDelay)

    $tooltipCloser = $('.tooltip-close.icon-x')

    if $tooltipCloser.length > 0
      $tooltipCloser.off('click')
      $tooltipCloser.on('click', GIG.Tooltip.helpers.hideTooltip)

    if cashBack?.showSideTutorial
      $('#clo-tutorial-iframe').on 'load', ->
        $('#clo-tutorial-iframe').height($('#clo-tutorial-iframe').contents().height())

    # FADE out the tooltip when scrolling down the page
    $window = $(window)

    $window.load ->
      if $('#cash-back-tutorial-tooltip').length
        $tooltipiframe = $('#clo-tutorial-tooltip-iframe')
        $tooltipiframe.attr('src', $tooltipiframe.attr('data-lazyload'))

        $tooltipiframe.on 'load', ->
          $tooltipiframe.height($tooltipiframe.contents().height())

    $window.scroll ->
      scrollTop = $window.scrollTop()
      height = $window.height()
      ratio = ((height - scrollTop) / height)
      $('#cash-back-tutorial-tooltip').css
        'opacity': ratio
      if ratio < 0.3
        $tooltipCloser.click()

    done()

  userTypeHandler: (userTypes, data) ->
    {cashBack, cookieDomain} = data
    displayCardsUserNeedsToClaimDeal(userTypes, cashBack, '#buy-link.buy-button:not(.pay-to-claim)')

    onModalClose = ->
      Cookie.set TUTORIAL_MODAL_SHOWN_COOKIE_NAME, 'true', TWENTY_YEARS_IN_SEC, cookieDomain

    showTutorialModal = (cookieDomain) ->
      return if Cookie.get(TUTORIAL_MODAL_SHOWN_COOKIE_NAME)
      GIG.Modal.open({id: 'clo-tutorial-modal'})
      GIG.Modal.onClose onModalClose, 'clo-tutorial-modal', true

      $('#clo-modal-tutorial-iframe').on 'load', ->
        $('#clo-modal-tutorial-iframe').height($('#clo-modal-tutorial-iframe').contents().height())

    showEnrollmentModal = (cookieDomain) ->
      return if Cookie.get(TUTORIAL_MODAL_SHOWN_COOKIE_NAME)
      GIG.Modal.open({id: 'clo-enrollment-modal'})
      GIG.Modal.onClose onModalClose, 'clo-enrollment-modal', true

      $('#clo-modal-enrollment-iframe').on 'load', ->
        $('#clo-modal-enrollment-iframe').height($('#clo-modal-enrollment-iframe').contents().height())

        eventMethod = if window.addEventListener then 'addEventListener' else 'attachEvent'
        eventer = window[eventMethod]
        messageEvent = if eventMethod == 'attachEvent' then 'onmessage' else 'message'

        eventer messageEvent, ((e) ->
          if e.data == 'cards_consented'
            GIG.Modal.close()
            $('#card-enroll-success').show()

          if e.data == 'card_enrollment_error'
            $('#clo-modal-enrollment-iframe').height($('#clo-modal-enrollment-iframe').contents().height())
        ), false

    acceptableBillingRecordTypes = cashBack.acceptableBillingRecordTypes.map((type) -> type.cardType)
    userHasProperCardTypeUnenrolled = _.intersection(userTypes.userUnconsentedTypes, acceptableBillingRecordTypes).length
    if cashBack.showCLOModalOnLoad and not cashBack.showTutorialTooltipOnLoad
      if userTypes.userConsentedTypes?.length
        return
      else if userHasProperCardTypeUnenrolled
        showEnrollmentModal cookieDomain
      else
        showTutorialModal cookieDomain

  showTutorialTooltip: (cookieDomain) ->
    return if Cookie.get(TUTORIAL_SHOWN_COOKIE_NAME)
    cookieDomain ?= window.location.hostname

    $tooltip = $('#cash-back-tutorial-tooltip')
    return unless $tooltip.length

    onTooltipClose = ->
      Cookie.set TUTORIAL_SHOWN_COOKIE_NAME, 'true', TWENTY_YEARS_IN_SEC, cookieDomain
    $tooltip.one 'click', '.tooltip-close', onTooltipClose

    $trigger = $('.cash-back .tooltip-trigger')
    GIG.Tooltip.helpers.tooltip.apply $trigger, [{preventDefault: ->}]

module.exports = CashBack
